import React, { Fragment } from 'react'
import estilos from './ViverosComponent.module.css'
import maguey from '../../../../../img/maguey.png'
import grass from '../../../../../img/grass.png'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

function ViverosComponent(props) {
    
    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.viveroclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.viveroclientehistorial)
        setOpenModalHistorial(true)
    }
    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className={`${estilos.section} text-center py-5 py-md-0`}>
                    <div className={`${estilos.card3dWrap} mx-auto`}>
                        <div className={`${estilos.card3dWrapper} mx-auto`}>
                            <div className={`${estilos.cardBack}`}>
                                <div className={props?.data.isbaja ? `${estilos.pricingWrapBaja}` : `${estilos.pricingWrap}`}>
                                    <h4 className={`${estilos.h4} mb-5`}></h4>
                                    <div className='row' style={{ marginTop: '50%', marginRight: '10%', fontFamily: 'Montserrat' }}>
                                        {props?.data?.isbaja == false &&
                                            <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                <Tooltip title="Ver historial de cambios">
                                                    <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                        <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        }
                                        {props?.data?.isbaja == true &&
                                            <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                <IconButton size="large" sx={{ p: 1 }} disableFocusRipple disableRipple disabled >
                                                    <HistoryRoundedIcon fontSize="inherit" sx={{ color: 'white' }} />
                                                </IconButton>
                                            </div>
                                        }
                                        <p className="mb-4 ps-5 pe-5"><b>Vivero:</b> {props?.data?.nombreparaje?.toUpperCase()}</p>
                                        <p className="mb-4 ps-5 pe-5"><b>Domicilio:</b> {props?.data?.calle?.toUpperCase() + ', ' + props?.data?.numeroexterior?.toUpperCase() + ', ' + props?.data?.localidad?.toUpperCase() + ', ' +
                                            props?.data?.municipio?.toUpperCase() + ', ' + props?.data?.distrito?.toUpperCase() + ', ' + props?.data?.estado?.toUpperCase() + ', ' + props?.data?.codigopostal?.toUpperCase()}</p>
                                    </div>
                                    <div className={`${estilos.imgWrap} ${estilos.img} ${estilos.img2}`}>
                                        <img src={grass} alt="" />
                                    </div>
                                    <div className={`${estilos.imgWrap} ${estilos.img} ${estilos.img7}`}>
                                        <img src={maguey} alt="" style={{ width: '110%' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Viveros"} />}

            </ThemeProvider>
        </Fragment >
    )
}

export default ViverosComponent